import { serializeActor } from 'ui-product-approvals-common/utils/actorKey';
export const hasUnavailableTemplateApprover = (template, approvers) => {
  if (!(template !== null && template !== void 0 && template.approvalSteps.length)) {
    return false;
  }
  const availableActorKeys = new Set(approvers.map(approver => serializeActor(approver.actor)));
  return template.approvalSteps.some(step => !availableActorKeys.has(serializeActor(step.actor)));
};
export const getInitialStepGroups = (template, approvers, defaultAgentApprover) => {
  const approversByActorKey = new Map(approvers.map(approver => [serializeActor(approver.actor), approver]));
  const unorderedApprovers = [];
  const approversByOrder = new Map();
  template === null || template === void 0 || template.approvalSteps.forEach(templateStep => {
    var _approversByOrder$get;
    const approver = approversByActorKey.get(serializeActor(templateStep.actor));
    if (!approver) {
      return;
    }
    if (templateStep.order === undefined) {
      unorderedApprovers.push(approver);
      return;
    }
    const stepApprovers = (_approversByOrder$get = approversByOrder.get(templateStep.order)) !== null && _approversByOrder$get !== void 0 ? _approversByOrder$get : [];
    stepApprovers.push(approver);
    approversByOrder.set(templateStep.order, stepApprovers);
  });
  const orderedGroups = [...approversByOrder.entries()].sort(([orderA], [orderB]) => orderA - orderB).map(([, stepApprovers]) => stepApprovers);
  const stepGroups = unorderedApprovers.length > 0 ? [unorderedApprovers, ...orderedGroups] : orderedGroups;
  if (!defaultAgentApprover) {
    return stepGroups;
  }
  if (stepGroups.length === 0) {
    return [[defaultAgentApprover]];
  }
  const [firstStep, ...remainingSteps] = stepGroups;
  return [firstStep.some(approver => serializeActor(approver.actor) === serializeActor(defaultAgentApprover.actor)) ? firstStep : [...firstStep, defaultAgentApprover], ...remainingSteps];
};